import { render, staticRenderFns } from "./resume-dialog-view.vue?vue&type=template&id=2ceaf937&"
import script from "./resume-dialog-view.vue?vue&type=script&lang=js&"
export * from "./resume-dialog-view.vue?vue&type=script&lang=js&"
import style0 from "./resume-dialog-view.vue?vue&type=style&index=0&id=2ceaf937&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports